import { z } from 'zod';

export const moldFormSchema = z.object({
  name: z.string()
    .min(1, 'El nombre es requerido')
    .max(100, 'El nombre debe tener máximo 100 caracteres'),
  code: z.string()
    .max(50, 'El código debe tener máximo 50 caracteres')
    .optional()
    .or(z.literal('')),
  type: z.string()
    .max(100, 'El tipo debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  tag: z.string()
    .max(100, 'El proyecto debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  customer_id: z.string()
    .uuid('ID de cliente inválido')
    .optional()
    .or(z.literal('')),
  nfc_tag_uid: z.string()
    .max(255, 'El UID NFC debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  current_location: z.string()
    .max(255, 'La ubicación debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  shelf_location: z.string()
    .max(10, 'La estantería debe tener máximo 10 caracteres')
    .optional()
    .or(z.literal('')),
  description: z.string()
    .max(500, 'La descripción debe tener máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
  material: z.string()
    .max(100, 'El material debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  dimensions: z.string()
    .max(100, 'Las dimensiones deben tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  number_of_pieces: z.number()
    .int('Debe ser un número entero')
    .positive('Debe ser un número positivo')
    .optional()
    .or(z.literal(0)),
  max_uses: z.number()
    .int('Debe ser un número entero')
    .positive('Debe ser un número positivo')
    .optional()
    .or(z.literal(0)),
  maintenance_hours: z.number()
    .int('Debe ser un número entero')
    .nonnegative('Debe ser un número no negativo')
    .optional()
    .or(z.literal(0)),
  cycle_time_minutes: z.coerce.number()
    .min(0, 'El tiempo debe ser mayor o igual a 0')
    .optional()
    .nullable(),
  is_active: z.boolean().default(true),
  notes: z.string()
    .max(1000, 'Las notas deben tener máximo 1000 caracteres')
    .optional()
    .or(z.literal('')),
});

export type MoldFormData = z.infer<typeof moldFormSchema>;
